import {
	ChangeDetectionStrategy,
	Component,
	Input,
	OnInit,
} from '@angular/core';

import { ISection } from 'phase/section/section';

@Component({
	selector: 'spr-section-title',
	templateUrl: './section-title.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
	host: {
		class: 'flex items-start space-x-3',
	},
})
export class SectionTitleComponent {
	@Input() public section: ISection;

	@Input() public isStarted: boolean;

	constructor() {}
}
